/* RESPONSIBLE TEAM: team-data-foundations */
import Predicate from 'predicates/models/predicate';
import { inject as service } from '@ember/service';
import { readOnly, map } from '@ember/object/computed';
import { computed } from '@ember/object';
export default Predicate.extend({
  appService: service(),
  intl: service(),
  isEditable: true,
  genericType: 'plan',
  isPlanType: true,
  defaultComparison: 'eq',
  plans: readOnly('appService.app.plans'),
  options: map('plans', function (plan) {
    return {
      label: plan.name,
      value: plan.id
    };
  }),
  isValid: computed('value', 'comparison', function () {
    if (['known', 'unknown'].includes(this.comparison)) {
      return true;
    }
    return ['eq', 'ne'].includes(this.comparison) && !!this.value;
  }),
  getDefaultValue() {
    return this.get('options.firstObject.value') ?? undefined;
  },
  _initializeValueForComparison(comparison) {
    if (['known', 'unknown'].includes(comparison)) {
      return null;
    } else if (this.hasNoValue) {
      return this.getDefaultValue();
    } else {
      return this.value;
    }
  }
});